import { Typography } from 'antd';

const { Title, Text } = Typography;

interface ErrorFallbackProps {
  error?: Error;
  errorMessage?: string;
}

export const ErrorFallback = ({ error, errorMessage }: ErrorFallbackProps) => {
  return (
    <div className='flex flex-col justify-center items-center h-screen p-8'>
      <Title level={2} className='!text-orange-500 !mb-4'>
        {errorMessage || 'Something went wrong'}
      </Title>
      {error && (
        <div className='mt-4'>
          <details>
            <Text className='cursor-pointer mb-2 block'>Error details</Text>
            <pre className='mt-2 p-2 bg-gray-100 rounded overflow-auto max-w-[80vw] text-sm'>{error.message}</pre>
          </details>
        </div>
      )}
    </div>
  );
};
